import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { types as actions } from '../../reducers/actions';
import { TagService } from '../../services';
import { editedTagAction, getTagsAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_TAG),
    switchMap(action =>
      TagService.edit(action.tag, store).pipe(
        switchMap(data => 
          concat(
            of(editedTagAction(data)),
            of(
              getTagsAction(
                store.getState().sites.currentSite.id
              )
            )
          )
        ),
        catchError(retryAuthentication(action$, 'epics/tags/editTag'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/editTag.js